module.exports = __webpack_public_path__ + "img/bureau-luthi-logo-main-full-black.bcc4d36c.svg";